import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const EmptyData: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="offers_history_listing_empty_data">
      <UIText1>Нет данных.</UIText1>
      <UIText1>Не нашли похожих квартир. Зайдите позже или выберите другой фильтр</UIText1>
    </div>
  );
};
